import StarIcon from "@mui/icons-material/Star";
import { Box } from "@mui/material";

import { theme } from "../mui-customs/Theme";
import Typography from "./Typography";

interface ReviewDisplayTagProps {
  rating?: number;
}

const ReviewDisplayTag = ({ rating }: ReviewDisplayTagProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <Box
        sx={{
          padding: "4px 6px",
          borderRadius: "6px",
          backgroundColor: theme.brand1[500],
          display: "flex",
          gap: "4px",
          alignItems: "center",
        }}
      >
        <StarIcon
          sx={{
            color: theme.whiteBg.WBG1,
            height: "18px",
            width: "18px",
          }}
        />
        <Typography
          variant="body2"
          sx={{ color: `${theme.whiteBg.WBG1} !important` }}
        >
          {rating ?? 0}
        </Typography>
      </Box>
      <Typography variant="title2" sx={{ color: theme.grey2[400] }}>
        Reviews
      </Typography>
    </Box>
  );
};

export default ReviewDisplayTag;
